"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackEvent = TrackEvent;
exports.WithCurrentAndLegacyOrganisationId = WithCurrentAndLegacyOrganisationId;
const index_1 = require("../index");
const AnalyticsConstants_1 = require("./AnalyticsConstants");
const AppInsightsService_1 = require("./AppInsightsService");
// Aims to be the TypeScript equivalent of IAnalyticsTracker.TrackEvent from C#
// See https://github.com/accuRx/rosemary/blob/trunk/src/Shared/accuRx.Extensions/Analytics/IAnalyticsTracker.cs
// Guidelines: https://www.notion.so/accurx/Analytics-Coding-Guidelines-b10c02a128ed4e4da218c52282c1feec
/**
 * Used to track analytics event of a NON logged in user
 * If tracking an event for a logged in user, please use `AnalyticsHelpers.TrackLoggedInEvent` instead.
 * */
function TrackEvent(eventName, customProperties) {
    const appInsights = (0, AppInsightsService_1.getAppInsights)();
    try {
        appInsights === null || appInsights === void 0 ? void 0 : appInsights.trackEvent({
            name: eventName,
        }, customProperties ? customProperties : {});
    }
    catch (e) {
        index_1.Log.error("Unexpected error tracking event in App Insights", {
            originalException: e,
        });
    }
}
/**
 * Legacy naming is used for backwards compatibility while we communicate that the legacy name is to be removed.
 */
function WithCurrentAndLegacyOrganisationId(customProperties, organisationId) {
    return Object.assign(Object.assign({}, customProperties), { [AnalyticsConstants_1.SharedAppInsightsCustomProperties.CurrentOrganisationId]: organisationId, [AnalyticsConstants_1.SharedAppInsightsCustomProperties.LegacyOrganisationId]: organisationId });
}
//# sourceMappingURL=AppInsightsAnalyticsTracker.js.map